import { Accounts } from '@or-sdk/accounts';

import { useAuth } from '@/stores';

import config from '../config';

const instance = new Accounts({
  sdkUrl: `${config.SDK_API_URL}`,
  token: () => {
    return `USER ${useAuth().reactiveToken}`;
  },
});

export default instance;
